
<template>
	<div class="pop-main flex-row">
		<div class='order-info'>
			
			<div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 20px;">
				<div class='title'>添加历史发单</div>
				<div style="display: flex; flex-direction: row; align-items: center;">
					<div>选择彩种：</div>
					<el-select v-model="lottery_sign" placeholder="选择彩种" @change="lotteryChange">
					    <el-option
					      v-for="item in lotterys"
					      :key="item.lottery_sign"
					      :label="item.lottery_name"
					      :value="item.lottery_sign">
					    </el-option>
					  </el-select>
				</div>
				<div style="display: flex; flex-direction: row; align-items: center; margin-left: 30px;">
					<div>选择日期：</div>
					<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" @change="dateChange"></el-date-picker>
				</div>
			</div>
			
			<div class="lottery-box">
				<Football :lottery_sign="lottery_sign" @addPlan="addPlanHandle" :date="date"></Football>
			</div>
		</div>
	</div>
</template>

<script>
	import Football from './Game/Football.vue';
	export default {
		components:{
			Football
		},
		data(){
			return {
				playType:'hhgg',
				lotterys:[
					{
						lottery_sign:'football',
						lottery_name:'竞彩足球'
					},{
						lottery_sign:'basketball',
						lottery_name:'竞彩篮球'
					},{
						lottery_sign:'peking',
						lottery_name:'北京单场'
					}
				],
				lottery_sign:'',
				date:'',
				matchList:[
				],
			}
		},
		methods:{
			addPlanHandle(e){
				this.$emit('addPlan', e);
			},
			getMatchData(){
				if(this.lottery_sign != '' && this.date != ''){
					let _this  = this;
					const _loading = this.$loading({ lock: true, text: '加载场次中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
					_this.$api.post("/Game/getFootballOdds", {lottery_sign:_this.lottery_sign, date:_this.date}).then(res=>{
						_loading.close();
						if(res.code == 200){
							_this.matchList = res.data.list;
						}
					}).catch(err=>{
						_loading.close();
						console.log(err);
					})
				}
			},
			dateChange(e){
				this.getMatchData();
			},
			lotteryChange(e){
				this.getMatchData();
			},
			addPlan(){
				this.addPlanShow = true;
			},
			handleClose(){
				this.addPlanShow = false;
			},
			tableRowClassName({row, rowIndex}) {
				if (rowIndex === 1) {
					return 'warning-row';
				} else if (rowIndex === 3) {
					return 'success-row';
				}
				return '';
			}
		}
	}
</script>

<style scoped lang="scss">
	.flex-row {
		display: flex; flex-direction: row; align-items: flex-start; justify-content: space-between;
	}
	.pop-main {
		height: 80vh;
		user-select: none;
	}
	.account-info {
		padding: 20px;
		border-radius: 10px;
		width: 310px;
		background-color: #f8f8f8;
	}
	.order-info {
		padding: 20px;
		border-radius: 10px;
		width: 100%;
		background-color: #f8f8f8;
	}
	.title {
		font-weight: bold;
		font-size: 18px;
		color: black;
		margin-right: 50px;
	}
	.form-line {
		margin: 10px 0;
		display: flex; flex-direction: row; align-items: center;
		.form-name {
			width: 50px;
			font-size: 16px;
		}
		.form-inp {
			width: 200px;
			margin-right: 10px;
		}
		.avatar {
			width: 60px; height: 60px; border-radius: 60px;
			margin-right: 10px;
		}
	}
	.tip {
		color: orangered;
	}
	.date-info {
		display: flex; flex-direction: row; align-items: center; justify-content: center;
		background-color: #3399ff;
		color: white;
		border-radius: 5px;
		padding: 5px 0;
		border-bottom: solid 1px #c9e1f0;
		.right {
			margin-left: 20px;
			cursor: pointer;
		}
	}
	.bb {
		border-bottom: solid 1px #c9e1f0;
	}
	.thr {
		background-color: #e8f6ff;
	}
	.th {
		display: flex; flex-direction: row; align-items: center;
		
		border-bottom: solid 1px #c9e1f0;
		color: #003f94;
		.week {
			height: 81px;
			line-height: 81px;
			text-align: center;
			width: 120px;
			border-right: solid 1px #c9e1f0;
			border-left: solid 1px #c9e1f0;
		}
		.comp {
			height: 81px;
			line-height: 81px;
			text-align: center;
			width: 100px;
			border-right: solid 1px #c9e1f0;
		}
		.time {
			height: 81px;
			line-height: 81px;
			text-align: center;
			width: 100px;
			border-right: solid 1px #c9e1f0;
		}
		.vs {
			height: 81px;
			line-height: 81px;
			text-align: center;
			width: 220px;
			border-right: solid 1px #c9e1f0;
		}
		.goal {
			height: 81px;
			line-height: 81px;
			text-align: center;
			width: 100px;
			border-right: solid 1px #c9e1f0;
			.sub-goal {
				height: 40px;
				line-height: 40px;
				position: relative;
			}
			.single {
				position: absolute;
				top: 0;
				left: 0;
				font-size: 12px;
				width: 20px;
				height: 20px;
				line-height: 20px;
				border-bottom-left-radius: 10px;
				border-bottom-right-radius: 10px;
				text-align: center;
				color: #ffffff;
				background-color: red;
			}
		}
		.h,.d,.a {
			height: 81px;
			line-height: 81px;
			width: 80px;
			text-align: center;
			border-right: solid 1px #c9e1f0;
			.bet-odds {
				height: 40px;
				line-height: 40px;
				cursor: pointer;
			}
		}
		.more {
			height: 81px;
			line-height: 81px;
			text-align: center;
			width: 80px;
			border-right: solid 1px #c9e1f0;
			color: #888888;
			cursor: pointer;
		}
		.result {
			height: 81px;
			line-height: 81px;
			text-align: center;
			width: 340px;
			border-right: solid 1px #c9e1f0;
		}
	}
</style>
<style>
	.el-table .warning-row {
		background: oldlace;
	}
	
	.el-table .success-row {
		background: #f0f9eb;
	}
</style>